<script>
    import { privacyCookieName } from '../utils';

    export default {
        data(){
            return  {
                privacyCookie: !!this.$cookies.get(privacyCookieName) || false,
            };
        },
        methods: {
            close() {
                if(!this.privacyCookie){
                    this.$cookies.remove(privacyCookieName, null, locations.cookie_domain);
                    this.$skokka.deleteFunctionalCookies();
                } else {
                    this.$cookies.set(privacyCookieName, '1' , '1d', '/', locations.cookie_domain);
                    this.$root.$emit('setPrivacyCookie', true);
                }
                $('#lightbox-manage-cookies').modal('hide');
            },
        }
    };
</script>
